import { AbstractQuery } from 'src/models/query';

export class GetUserOnlineQuery extends AbstractQuery {
	name = 'IFS_UserOnline_Query_Queries_GetUserOnlineQuery';
	parameters = [{}];
}

export class GetUserStatesQuery extends AbstractQuery {
	name = 'IFS_UserState_Query_Queries_GetUserStatesQuery';
	parameters = [{}];
}
